import { useState } from 'react';
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel
} from '@tanstack/react-table';

const useAdvanceTable = ({
  columns,
  data,
  sortable,
  pagination,
  initialState,
  perPage = 10
}) => {
  const [globalFilter, setGlobalFilter] = useState('');
  const [paginationState, setPaginationState] = useState({
    pageIndex: 0,
    pageSize: pagination ? perPage : (data?.length || 1000)
  });
  
  const table = useReactTable({
    data: data || [],
    columns: columns || [],
    enableSorting: sortable,
    enableGlobalFilter: true,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    state: {
      globalFilter,
      pagination: paginationState,
      ...initialState
    },
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPaginationState,
    globalFilterFn: 'includesString',
    autoResetPageIndex: false,
    manualPagination: false,
    debugTable: false,
    debugHeaders: false,
    debugColumns: false
  });

  return {
    ...table,
    globalFilter,
    setGlobalFilter
  };
};

export default useAdvanceTable; 